import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { Component, Input, ViewContainerRef, OnInit } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { BiUrls } from '../../biUrls';
import { RoleAuthService } from '../services/roleAuthService.service';

@Component({
    selector: 'roleAuthorization',
    templateUrl: 'roleAuthorization.component.html',
    styleUrls: ['../../biAdminStyles.css']
})

export class roleAuthorizationComponent implements OnInit{
    public accessDenied: boolean = false;
    public loader: boolean = true;
    public mainPage: boolean = true;
    public isEdit: boolean = false;
    public roleList: any = [];
    public roleIdList: any = [];
    public countMap: any = new Map();
    public trackHides = null;
    public roleCounts;
    public roleId : any = [];
    public roleName: string;

    public pageNo: number = 1;
    public pageSize: number = 10;
    public totalPages: number;
    public totalRoles:number;

    
    constructor( public roleAuthService: RoleAuthService,
        public MDMAuthService: MDMService,
        public toastr: ToasterComponent,
        public vcr: ViewContainerRef) {
        this.toastr.setViewRef(this.vcr);        
    }

    ngOnInit(){
        if(this.MDMAuthService.isBIAdmin){
            this.loadData();
        }else{
            this.accessDenied = true;
        }
    }

    public loadData() {
        let self = this;
        self.loadRoles().then(() => {
                //self.loadWidgetCounts();
        }, (err) => {
            console.error(err);
        });
    }

    async loadRoles(){
        this.loader = true;
        // let pageNo = 1;
        // let pageSize = 10;
        this.roleList = [];
        this.roleIdList = [];
        let res = await this.roleAuthService.getRoleList(this.pageNo, this.pageSize);
        // res = JSON.parse(JSON.stringify(res));
        this.roleList = res && res.content ? res.content : null;
        this.totalPages = res.totalPages;
        this.totalRoles = res.totalElements;
        this.loader = false;
        this.mainPage = true;
    }

    // async loadWidgetCounts(){
    //     this.roleList.forEach(element => {
    //         this.roleIdList.push(element.id);
    //     });
    //     this.loader = true;
    //     this.roleCounts = await this.roleAuthService.getWidgetCount(this.roleIdList);
    //     this.setCountMap();
    //     this.loader = false;
    // }

    public OnPageSizeChanged(event) {
        this.pageSize = event.target.value;
        this.loadRoles();
    }

    public onPageChange(event: number): void {        
        this.pageNo = event;
        this.loadRoles();
    }

    setCountMap(){
        if(this.roleCounts){
            let countArr = this.roleCounts;
            countArr.forEach(countObj => {
                this.countMap.set(countObj.roleId, countObj.count);
            });
        }
    }

    clicked() {
        this.trackHides = null;
    }
    
    tableActions(value) {
        this.trackHides = (this.trackHides == value ) ? null : value;
    }

    editRoles(id, name) {
        this.trackHides = null;
        //this.roleAuthService.setRoleId(id,name);
        this.roleId[0] = id;
        this.roleName = name;
        this.roleList = []
        this.isEdit = true;
    }

    onEdit(event){
        // this.toastr.setViewRef(this.vcr);
        this.loadData();
        this.isEdit = false;
    }
    

}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/roleAuthorization.component.ts